<div class="adc-loader1" *ngIf="type=='style1'"></div>
<div class="adc-loader2" *ngIf="type=='style2'"></div>
<!-- <div class="adc-loader3" *ngIf="type=='style3'"></div> -->
<div class="set-size charts-container" *ngIf="type=='style3'">
    <div class="pie-wrapper" [ngClass]="progressVal ? 'progress-' + progressVal : ''">
        <span class="label">{{progressVal}}<span class="smaller">%</span></span>
        <div class="pie">
            <div class="left-side half-circle"></div>
            <div class="right-side half-circle"></div>
        </div>
    </div>
</div>